<template>
  <div>
    <div>
      <span class="lot-name">{{ lotName }}</span>
      <span v-if="lot-id" class="lot-d">({{ lotInfo.lotId }})</span>
    </div>
    <div class="date-info">
      {{ $t('building_page.from') }}{{ startDate }}{{ $t('building_page.to') }}{{ lotInfo.landLeases }}
      <span v-if="lotInfo.optionForRenewal">{{ $t('building_page.optionForRenewal') }}</span>
    </div>
  </div>
</template>

<script>
import timeUtils from '@/mixins/timeUtils';

export default {
  props: ['lotInfo'],
  mixins: [timeUtils],
  computed: {
    lotName() {
      return this.$i18n.locale === 'en' ? this.lotInfo.lotEn : this.lotInfo.lotZh;
    },
    startDate() {
      return this.lotInfo.landLeasesDate ?
        this.str2time(this.lotInfo.landLeasesDate).format(this.lotInfo.landLeasesDateFormat || 'YYYY') :
        '';
    },
  },
};
</script>

<style scoped>
.date-info {
  font-size: 10px;
}
</style>
